import { MainLoader } from "@/components/loader/MainLoader"
import { useAuthContext } from "@/context-state/AuthContext"
import { useEffect } from "react"
import * as API from "@/services/api"
import { toast } from "sonner"

export const AccountSpacesDataProvider = ({ children }) => {
    
    const { setManySpaceUsers, spaces, getSpaceUsers } = useAuthContext()

    const missingSpaceUsers = spaces.filter(space => !getSpaceUsers(space._id)?.length)


    const fetchAllSpaceUsers = async () => {
        try {
            // for each space, fetch its users
            const spaceIdsWithUsersPromises = spaces.map(space => {
                return API.getSpaceUsers(space._id).then(({ data }) => {
                    return { spaceId: space._id, users: data }
                })
            })

            const spaceIdsWithUsers = await Promise.all(spaceIdsWithUsersPromises)
            setManySpaceUsers(spaceIdsWithUsers)

        } catch (e) {
            console.error(e)
            toast.error('Failed to fetch space users')
        }
    }

    useEffect(() => {
        if (missingSpaceUsers) {
            fetchAllSpaceUsers()
        }
    }, [])

    return missingSpaceUsers ? children : <MainLoader className="bg-hero-background bg-cover bg-center bg-no-repeat" />
}